var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.recom-resales-stocks'),"text":_vm.$t('resalesStocks.description'),"name":"resalesStocks","url":_vm.$listRoutes.recomResalesStock,"table":_vm.resalesStocks,"filters":_vm.resalesStocksFilters,"fields":_vm.fields,"display-date":true,"filtersWording":_vm.filtersWording}})
}
var staticRenderFns = []

export { render, staticRenderFns }